import "./three.js"

export const THREE2 = globalThis.THREE
